import axios from "axios";
import { getSessionId } from "../../CommonAPI/User";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";

const WS_URL = "wss://ws1.aliceblueonline.com/NorenWS";
const SESSION_API =
  "https://ant.aliceblueonline.com/rest/AliceBlueAPIService/api/ws/createWsSession";

const client_id = "YOUR_CLIENT_ID";
const api_key = "YOUR_API_KEY";

let ws = null;

export const getSessionIdFromAPI = async () => {
  try {
    const response = await getSessionId();
    return {
      userId: response.Userid,
      sessionId: response.Access_Token,

    };
  } catch (error) {
    console.error("Error fetching credentials:", error);
    return null;
  }
};

export async function CreateSocketSession(type, userid, userSession1) {
  return axios.post(SESSION_API, type, {
    headers: {
      Authorization: `Bearer ${userid} ${userSession1}`,
    },
  });
}
async function ConnectSocket(onResponse, channelList, userId, userSession) {
  const url = "wss://ws1.aliceblueonline.com/NorenWS/";
  let socket;

  socket = new WebSocket(url);

  socket.onopen = function () {
    var encrcptToken = CryptoJS.SHA256(
      CryptoJS.SHA256(userSession).toString()
    ).toString();

    var initCon = {
      susertoken: encrcptToken,
      t: "c",
      actid: userId + "_" + "API",
      uid: userId + "_" + "API",
      source: "API",
    };

    socket.send(JSON.stringify(initCon));
  };

 socket.onmessage = async function (msg) {
  try {
    var response = JSON.parse(msg.data);
    
    // Price Response
    if (response.lp || response.sp1) {
      await onResponse(response);
    }

    // Subscription ACK
    if (response.s === "OK") {

      if (Array.isArray(channelList) && channelList.length > 0) {
        for (let ch of channelList) {
          let json = { k: ch, t: "t" };
          socket.send(JSON.stringify(json));
        }
      } else if (typeof channelList === "string") {
        let json = { k: channelList, t: "t" };
        socket.send(JSON.stringify(json));
      }
    } else if (response.s === "not_ok") {
      console.error("Subscription Failed:", response); // 👈 यहाँ reason मिलेगा
    }
  } catch (err) {
    console.error("Message parse error:", err, msg.data);
  }
};


  socket.onerror = function (error) {
    console.error("WebSocket Error:", error);
  };
  socket.onclose = function (event) {
    if (event.wasClean) {
    } else {
      console.error("Connection closed unexpectedly");
    }
  };
}

// MAIN
export const connectWebSocket = async (
  credentials,
  instrument,
  onPriceUpdate
) => {
  const type = { loginType: "API" };

  if (!credentials || !credentials.userId || !credentials.sessionId) {
      credentials = await getSessionIdFromAPI();
  }

  const { userId, sessionId } = credentials;




  if (!userId || !sessionId) {
    // Swal.fire("Error", "Missing userId or sessionId", "error");
    return;
  }

  try {
    const res = await CreateSocketSession(type, userId, sessionId);
    

    ConnectSocket(onPriceUpdate, instrument, userId, sessionId);
  } catch (error) {
    console.error("Error during WebSocket setup:", error);
  }
};
